/** @jsx jsx */
import { Flex } from "@eworkit/iris";
import React from "react";
import { FC } from "react";
import { CompositeItem } from "reakit/Composite";
import { jsx } from "theme-ui";

import { useTimeReportCalendarGrid } from "./grid/TimeReportCalendarGridContext";

interface TimeReportCalendarProjectRowGroupActionsProps {
  columns: number;
}

export const TimeReportCalendarProjectRowGroupActions: FC<TimeReportCalendarProjectRowGroupActionsProps> = ({
  columns,
  children,
}) => {
  const { compositeState } = useTimeReportCalendarGrid();

  return (
    <React.Fragment>
      {Array.from({ length: columns }).map((_, idx) => {
        if (idx === columns - 1) {
          return (
            <div key={idx} role="gridcell" sx={{ display: "table-cell", verticalAlign: "middle" }}>
              <Flex alignItems="center" justifyContent="flex-end" sx={{ pr: 8 }}>
                {children}
              </Flex>
            </div>
          );
        }

        return (
          <CompositeItem {...compositeState} as="div" role="presentation" key={idx} sx={{ display: "table-cell" }} />
        );
      })}
    </React.Fragment>
  );
};
